<template>
    <div>
        <navigation :brand="$route.query.brandName" :model="$route.query.model"></navigation>
        <div class="main-wrapper">
            <div class="row">
                <div class="phone-wrapper col-lg-4 col-xs-12" v-for="(memory,i) in memmories">
                    <router-link :to="{name: 'details', query: {model: $route.query.model, brandName: $route.query.brandName, capacity:memory.capacity}}">
                        <div class="phone">
                            <div class="block-img-wrapper">
                                <img :src="$root.$data.phonesObject[$route.query.brandName].img" alt=""> <!--ovde izmeni sliku-->
                            </div>
                            <div class="phone-name">
                                <p>{{memory.capacity}}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from './Navigation'

export default {
  components: {Navigation},
  name: 'phone-memory',
  data () {
    return {
      memmories: []
    }
  },
  methods: {},
  created () {
    let brand
    brand = this.$root.$data.phonesObject[this.$route.query.brandName]
    brand.models.forEach((el) => {
      if (el.name === this.$route.query.model) {
        this.memmories = el.memmories
      }
    })
  }

}
</script>

<style scoped>

</style>
